import { useQuery } from "react-query";
import { getInvoiceConstant } from "./service";

export const useGetInvoiceConstant = () => {
  return useQuery({
    queryKey: "invoiceConstant",
    queryFn: () => getInvoiceConstant(),
  });
};
